<template>
  <v-ons-page id="area_page">
    <v-ons-toolbar v-show="isMobile">
      <div class="left" @click="popPage()">
        <div class="history_back">
          <img src="../assets/images/common/arrow_back.svg" alt="戻る">
          <span>戻る</span>
        </div>
      </div>
      <div class="center title">エリアを選択</div>
      <div class="right"></div>
    </v-ons-toolbar>
    <header v-show="!isMobile">
      <div class="left"></div>
      <div class="center"><span>エリアを選択</span></div>
      <div class="right close" @click="hideSelectAreaDialog()"><img src="../assets/images/common/close.svg" alt="閉じる"></div>
    </header>
    <div id="contents">
      <div class="area_item" v-for="(select, i) of selectAreas" :key="i">
        <h2>{{select.label}}</h2>
        <dl class="select_area_accordion">
          <dt v-accordion>{{select.accordion_label}}</dt>
          <dd>
            <ul class="area_buttons">
              <li v-for="(area, i) of select.area" :key="i">
                <button type="button" @click="locationMap(area.id, area.name)" v-ripple>{{area.name}}</button>
              </li>
            </ul>
          </dd>
        </dl>
      </div>
      <div class="area_item">
        <h2>その他エリア</h2>
        <ul class="area_buttons">
          <li v-for="(radio, i) of radioAreas" :key="i"><button type="button" @click="locationMap(radio.id, radio.name)" v-ripple>{{radio.name}}</button></li>
        </ul>
      </div>
    </div>
  </v-ons-page>
</template>

<script>
import _ from 'lodash';
import $ from "jquery";
import store from '../store/store';

import ApiService from '../services/api-service.js';

export default {
  name: 'SelectArea',
  components: {
  },
  data() {
    return {
      selectAreas: [],
      radioAreas: [],
    };
  },
  directives: {
    accordion: {
      bind: function(el) {
        el.addEventListener('click', (event) => {
          // 他アコーディオンが開いている場合は閉じる
          const openAccordion = $('.select_area_accordion.open');
          if (openAccordion.length > 0 && el.closest('dl') !== openAccordion[0]) {
            const element = $(openAccordion).eq(0);
            element.toggleClass('open');
            $('>dd', element).slideToggle(100);
          }

          $(el).closest('dl').toggleClass('open');
          $('+dd', el).slideToggle(100);
        }, false);
      }
    }
  },
  computed: {
    isMobile: function() {
      return store.state.isMobile;
    },
  },
  watch: {
    isMobile: _.throttle(function(newVal, oldVal) {
      // PC -> SP
      if (newVal === true && oldVal === false) {
        store.dispatch('updateShowSelectAreaDialog', false);
      }

      // SP ->PC
      if (newVal === false && oldVal === true) {
        if (this.$router.currentRoute.name === 'SelectArea') {
          this.popPage();
        }
      }
    }, 1000),
  },
  methods: {
    /**
     * 前画面に戻ります
     */
    popPage() {
      this.$router.back();
    },
    /**
     * エリア選択モーダルを非表示にします
     */
    hideSelectAreaDialog() {
      store.dispatch('updateShowSelectAreaDialog', false);
    },
    /**
     * 地図画面に遷移します
     */
    locationMap(code, name) {
      const param = {
        'code': code
      }

      ApiService.areaSearch(param)
        .then(data => {
          const ids = data.info;
          store.dispatch('updateShowSelectAreaDialog', false);
          const typeParam = {
            'type': 'area',
            'text': name
          }
          store.dispatch('updateSearchType', typeParam);
          store.dispatch('updateResult', ids);
          
          if (this.isMobile) {
            this.$router.replace({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
          } else {
            this.$router.push({name: 'Map', params: {animation: 'slide'}}).catch(err => {});
          }
        }, error => {
          console.log(error);
        });
    }
  },
  created: function() {
    ApiService.areaInfo()
      .then(areaInfo => {
        this.selectAreas = areaInfo.info.select;
        this.radioAreas = areaInfo.info.radio;
      }, error => {
        console.log(error);
      });
  },
  mounted: function() {

  }
}
</script>
<style lang="scss" scoped>
@import "../assets/styles/select_area.scss";
</style>